import type { SVGProps } from "react";

export function IconDarkPurplePersonSquare(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 34 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="4.625"
        y="4.125"
        width="24.75"
        height="24.75"
        stroke="#3E2247"
        strokeWidth="2.0625"
      />
      <circle
        cx="17"
        cy="13.0625"
        r="4.8125"
        stroke="#3E2247"
        strokeWidth="2.0625"
      />
      <path
        d="M25.25 28.875V22H8.75V28.875"
        stroke="#3E2247"
        strokeWidth="2.0625"
      />
    </svg>
  );
}
